import BaseTransformer from "./base.transformer"
import AssetsTransformer from "./assets.transformer"

export const baseUri = "/api/users"
class UsersTransformer extends BaseTransformer {
  static fetch(user) {
    const uuid = this.transformUuid(user)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      name: user.name,
      lastName: user.lastName,
      email: user.email,
      locale: user.locale,
      timezone: user.timezone,
      shortLocale: user.shortLocale,
      account: user.accounts ? user?.accounts[0] : null,
      accounts: user.accounts,
      socialCreated: user.socialCreated,
      avatarUrl: user.avatar?.uri,
      avatar: user.avatar ? AssetsTransformer.fetch(user.avatar) : {},
      createdAt: user.createdAt,
      isSocialCreated: user.isSocialCreated
    })
  }
}

export default UsersTransformer
